import React, { useState } from 'react'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import { HeadingText, Divider, Dropdown, Button } from '@paypalcorp/pp-react'
import SocialMediaLink from '../shared/components/social-media-link'
import getContent from 'pp-react-l10n'
const l10n = getContent('pages/seller/social')

const Container = glamorous.div({
  margin: '10px',
  '& > hr': {
    margin: '30px 0',
  },
  '@media(max-width: 414px)': {
    margin: 0,
  },
  '& .nextButton': {
    textAlign: 'center',
    '& > button': {
      width: 300,
      marginTop: 48,
    },
  },
})

const FormField = glamorous.div({
  margin: '20px 0',
})

Social.propTypes = {
  phoneData: PropTypes.array,
  emailData: PropTypes.array,
  locationData: PropTypes.array,
}

Social.defaultProps = {
  phoneData: [
    {
      label: '650-456-1111',
      value: '+16504561111',
    },
    {
      label: l10n('doNotShow', { value: '650-456-1111' }),
      value: 'donotshow',
    },
  ],
  emailData: [
    {
      label: 'email1@paypal.com',
      value: 'email1@paypal.com',
    },
    {
      label: l10n('doNotShow', { value: 'email1@paypal.com' }),
      value: 'donotshow',
    },
  ],
  locationData: [
    {
      label: 'San Jose, CA, USA',
      value: 'San Jose, CA, USA',
    },
    {
      label: 'CA',
      value: 'CA',
    },
    {
      label: l10n('doNotShowLocation', { value: 'email1@paypal.com' }),
      value: 'donotshow',
    },
  ],
}

function Social(props) {
  const [isFormValid, setIsFormValid] = useState(false)
  return (
    <Container data-test-id="seller-social-screen">
      <HeadingText size="md" role="heading" aria-level="1">
        {l10n('title')}
      </HeadingText>
      <p>{l10n('info')}</p>
      <Divider />
      <SocialMediaLink handleValidState={setIsFormValid} />
      <Divider />
      <p>{l10n('formTitle')}</p>
      <FormField>
        <Dropdown label={l10n('formPhone')} options={props.phoneData} />
      </FormField>
      <FormField>
        <Dropdown label={l10n('formEmail')} options={props.emailData} />
      </FormField>
      <FormField>
        <Dropdown label={l10n('formLocation')} options={props.locationData} />
      </FormField>
      {isFormValid ? (
        <div className="nextButton">
          <Button>{l10n('nextButton')}</Button>
        </div>
      ) : null}
    </Container>
  )
}
export default Social
